import moduleFactory from '../moduleFactory'
const namespace = 'app-functions'

const store = moduleFactory(namespace)

const data = store.getters.data

store.getters.data = state => (dispatch) => {
  return data(state)(dispatch).map(f => ({ id: f.id, name: `permission.${f.id}` }))
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/app-functions.js